/**
 * A SEVERITY'S MARK (`modules/alarms/severity.ts`), the same on every list of alarms: Critical a filled
 * disc, Major a filled triangle, Minor an open triangle, Unknown an open ring. Shapes, never colour
 * alone (WCAG 1.4.1); each carries its word as its accessible name.
 */
import type { ReactNode } from 'react';
import { severityWord } from '@/modules/alarms/severity';

export function SeverityMark({ severity, size = 10 }: { severity: string; size?: number }): ReactNode {
  const s = severity.toLowerCase();
  const word = severityWord(s);
  return (
    <svg role="img" aria-label={word} width={size} height={size} viewBox="0 0 10 10" className="inline-block shrink-0">
      <title>{word}</title>
      {s === 'critical' ? (
        <circle cx="5" cy="5" r="4.6" fill="var(--danger)" />
      ) : s === 'major' ? (
        <path d="M5 0.6 9.6 9.2H0.4Z" fill="var(--warn)" />
      ) : s === 'minor' ? (
        <path d="M5 1.4 9 8.6H1Z" fill="none" stroke="var(--warn)" strokeWidth="1.5" strokeLinejoin="round" />
      ) : (
        <circle cx="5" cy="5" r="4.1" fill="none" stroke="var(--muted-fg)" strokeWidth="1.5" />
      )}
    </svg>
  );
}
